import { getMatchDate } from './dateHelper'

export interface MatchLike {
  date: string
  time?: string
  score?: string | null
}

export function hasKnownScore(match: MatchLike | null | undefined): boolean {
  if (match?.score == null) return false
  const s = String(match.score).trim()
  return s !== '' && s.toLowerCase() !== 'null'
}

/** Kickoff passed and final score is stored on the match. */
export function isMatchPlayedWithScore(match: MatchLike | null | undefined): boolean {
  if (!match?.date) return false
  const kickoff = new Date(getMatchDate(match, true)).getTime()
  if (Number.isNaN(kickoff)) return false
  return kickoff <= Date.now() && hasKnownScore(match)
}

/** Future kickoff, or started/live but score not yet updated. */
export function isMatchUpcomingForPlayer(match: MatchLike | null | undefined): boolean {
  if (!match) return false
  return !isMatchPlayedWithScore(match)
}

export function isLiveAwaitingScore(match: MatchLike | null | undefined): boolean {
  if (!match?.date) return false
  const kickoff = new Date(getMatchDate(match, true)).getTime()
  if (Number.isNaN(kickoff)) return false
  return kickoff <= Date.now() && !hasKnownScore(match)
}

export function sortPlayedByKickoffDesc<T>(
  items: T[],
  getMatch: (item: T) => MatchLike | null | undefined,
): T[] {
  return [...items].sort((a, b) => {
    const ta = new Date(getMatchDate(getMatch(b)!, true)).getTime()
    const tb = new Date(getMatchDate(getMatch(a)!, true)).getTime()
    return ta - tb
  })
}

export function sortUpcomingByKickoff<T>(
  items: T[],
  getMatch: (item: T) => MatchLike | null | undefined,
): T[] {
  return [...items].sort((a, b) => {
    const ma = getMatch(a)
    const mb = getMatch(b)
    const ta = new Date(getMatchDate(ma!, true)).getTime()
    const tb = new Date(getMatchDate(mb!, true)).getTime()
    const liveA = isLiveAwaitingScore(ma)
    const liveB = isLiveAwaitingScore(mb)
    if (liveA !== liveB) return liveA ? -1 : 1
    if (liveA && liveB) return tb - ta
    return ta - tb
  })
}
